import axiosClient from './axiosClient';
import { FileMeta } from '@/types/files';


export const fileAPI = {
  // ✅ List files (optionally filtered by task_id, source, and/or comment_id)
  getFiles: async (
    taskId?: string,
    source?: string,
    commentId?: string
  ): Promise<FileMeta[]> => {
    const params: Record<string, string> = {};
    if (taskId) params.task_id = taskId;
    if (source) params.source = source;
    if (commentId) params.comment_id = commentId;

    const res = await axiosClient.get('/attachment', { params });
    return res.data.files || res.data;
  },

  // ✅ Upload files (accepts optional "source" and "commentId")
  uploadFiles: async (
    files: File[],
    taskId?: string,
    source?: string,
    commentId?: string,
    uploadedBy?: string,
    uploadedUserEmail?: string
  ): Promise<FileMeta[]> => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    if (taskId) formData.append('task_id', taskId);
    if (source) formData.append('source', source);
    if (commentId) formData.append('comment_id', commentId);
    if (uploadedBy) formData.append('uploaded_by', uploadedBy);
    if (uploadedUserEmail) formData.append('uploaded_user_email', uploadedUserEmail);

    const res = await axiosClient.post('/attachment/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return res.data.uploaded || res.data.files || res.data;
  },

  // ✅ Delete file
  deleteFile: async (fileId: string): Promise<void> => {
    await axiosClient.delete(`/attachment/${fileId}`);
  },

  // ✅ Download file
  downloadFile: async (fileId: string, filename?: string): Promise<void> => {
    const res = await axiosClient.get(`/attachment/${fileId}/download`, {
      responseType: 'blob',
    });
    const blob = new Blob([res.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename || fileId;
    link.click();
  },

  // ✅ Preview file (get blob URL for inline display)
  previewFile: async (fileId: string): Promise<string> => {
    const res = await axiosClient.get(`/attachment/${fileId}/preview`, {
      responseType: 'blob',
    });
    return window.URL.createObjectURL(res.data);
  },
};
